<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :title="'修改记录('+row.stationName+')'"
    width="1000px"
    @close="hide"
  >
    <div v-infinite-scroll="load" class="content-wrapper" :infinite-scroll-distance="100">
      <a-timeline v-if="dataList && dataList.length>0">
        <a-timeline-item v-for="(t,index) in dataList" :key="index">
          <div class="line">{{ t.createTime }}</div>
          <div class="text">
            <div class="label">操作人</div>
            <div class="value-more">
              {{t.operatorName||'-'}}
              <span v-if="t.operatorPhone">({{ t.operatorPhone }})</span>
            </div>
          </div>
          <div class="text">
            <div class="label">变更内容</div>
            <div class="value">
              <collapse
               :active-name='!t.expand?"0":"1"'
                :data-list="t.changedValues"
                title-key="propertyName"
                content-key="oldValue"
              />
               <div class="center"><a-icon type="double-right" /></div>
               <collapse
                :active-name='!t.expand?"0":"1"'
                :data-list="t.changedValues"
                title-key="propertyName"
                content-key="newValue"
              />
            </div>
          </div>
          <!--查看更多内容按钮 -->
          <div v-if='showExpand(t)' class="more">
            <span class="inner" @click='handleWatch(index)'>
              {{innerHtml(t)}}
              <i v-if="!t.expand" class="el-icon-arrow-down"></i>
            </span>
          </div>
        </a-timeline-item>
      </a-timeline>
      <a-empty v-else description="暂无站点修改记录"/>
    </div>
    <div class="footer">
      <a-button type="primary" @click="hide">
        关 闭
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import moment from 'moment'
import {stationChangeLog} from '../../api'
import  collapse from './collapse.vue'

export default {
  components:{collapse},
  data() {
    return {
      visible: false,
      dataList:[],
      row:{},
      page:1,
      size:100,
      total:0,
      showNumber:10,
    };
  },
  methods: {
    async show(row){
      this.dataList=[];
      this.page=1;
      this.size=100;
      this.total=0;
      this.row=row;
      this.visible=true
      this.fetchData()
    },
    hide(){
      this.visible=false;
    },
    async fetchData(){
      const data=await stationChangeLog({
        stationCode:this.row.stationCode
      },this.page,this.size)
      const list=data.records.map(t=>({
        ...t,
        createTime:t.createTime?moment(t.moment).format('YYYY-MM-DD HH:mm:ss'):'',
        expand:false
      }))
      this.dataList=this.dataList.concat(data.records && data.records.length>0?list:[])
      this.total=data.total
    },
    load(){
      if(this.dataList.length<this.total){
        this.page+=1;
        this.fetchData()
      }
    },
    handleWatch(index){
      // 查看更多内容
      const tt=this.dataList[index]
      this.dataList.splice(index,1,{
        ...tt,
        expand:!tt.expand
      })
    },
    showExpand(item){
      // 是否展示更多
      return item.changedValues.length>this.showNumber
    },
    innerHtml(item){
      if(!item.expand){
        return `查看剩余${item.changedValues.length-this.showNumber}项内容`
      }
      return ''
    }
  },
};
</script>

<style lang="less" scoped>
.footer{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: right;
  padding:10px 30px 10px 0;
  box-sizing: border-box;
  background: #fff;
}
.content-wrapper{
  height: 900px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top:10px;
  box-sizing: border-box;
}
.text{
  display: flex;
  margin-bottom: 8px;
  .label{
    color:#999;
    width: 80px;
  }
  .value-more{
    color:#333;
  }
  .value{
    display: flex;
    display: flex;
    justify-content: space-between;
    line-height:26px;
    flex:1;
    overflow: hidden;
    .center{
      flex-basis: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
    }
  }
}
.more{
  color:#06B880;
  margin:14px 0;
  text-align: center;
  cursor: pointer;
}
</style>
